import ProductFeed from '@/organisms/ProductFeed/ProductFeed';
import {StyledColorBlock} from '@/pages/styles';
import {getFeaturedArt} from '@/redux/actions/featuredArtActions';
import {STATUS_FAILED, STATUS_IDLE, STATUS_SUCCEEDED} from '@/redux/actionTypes';
import {selectFeaturedArt} from '@/redux/reducers/featuredArtReducer';
import colors from '@/theme/constants/colors';
import {pushGAFeaturedArtEvent} from '@/utils/gtm';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {section} from './content';
import {FeaturedArtSectionProps} from './typings';

const CARD_NUMBER = 4;

const FeaturedArtSection = ({}: FeaturedArtSectionProps): JSX.Element | null => {
  // Hooks
  const dispatch = useDispatch();

  // Redux selectors
  const {data: products, status} = useSelector(selectFeaturedArt);

  // Variables
  const [loading, setLoading] = useState(!products.length);

  const gaViewAll = () => {
    pushGAFeaturedArtEvent('viewAll');
  };

  const gaClickProduct = (position) => {
    pushGAFeaturedArtEvent('click', position);
  };

  const gaProductFavourite = (position) => {
    pushGAFeaturedArtEvent('favourite', position);
  };

  useEffect(() => {
    if (
      !!products.length &&
      loading &&
      (status.client === STATUS_SUCCEEDED || status.client === STATUS_FAILED)
    )
      setLoading(false);

    if (
      !products.length &&
      (status.ssr === STATUS_IDLE || status.ssr === STATUS_FAILED) &&
      status.client === STATUS_IDLE
    )
      dispatch(getFeaturedArt({limit: CARD_NUMBER}));
  }, [status.client]);

  return status.client === STATUS_FAILED ? null : (
    <StyledColorBlock $background={colors.grey25}>
      <ProductFeed
        title={section.name}
        products={products}
        viewAllLink={section.viewAllLink}
        gaEvents={{
          viewAll: gaViewAll,
          productClick: gaClickProduct,
          productFavourite: gaProductFavourite,
        }}
        loading={loading}
      />
    </StyledColorBlock>
  );
};

export default FeaturedArtSection;
